import { RegistrationConfig } from '../../models/config/registration-config.interface';
import { mockRegistrationFeatures } from './registration-features.mock';

export const mockRegistrationConfig: RegistrationConfig = {
  adobeCampaignApi: 'adobeCampaignApi',
  adobeCampaignBrand: 'WHR',
  adobeCampaignEventType: 'wpThankYouForRegistering',
  applianceLookupUrlBase: 'https://api.aws.preprod.domgen-usa.com',

  applianceMaximumAgeInMonths: 96,
  applianceRegistrationLimit: 10,
  callCentreNumber: '+1-800-MOCK-123',
  commonApi: 'commonApi',
  cpgFinderApi: 'https://api.aws.preprod.domgen-usa.com/v1/cpgfinder',
  features: mockRegistrationFeatures,
  checkoutApi: 'checkoutApi',
  modelNumberSearchEnabledBrands: [],
  possibleNowApi:
    'https://https://pmstg.mypreferences.com/api/3/whirlpool/preferences',
  possibleNowFilterId: 'possibleNowFilterId',
  possibleNowSalt: 'possibleNowSalt',
  registrationApi: 'https://api.aws.preprod.domgen-usa.com/v1/quote-internal',
  registriaUsersApi:
    'https://api.aws.preprod.domgen-usa.com/v1/registria-proxy/users',
  retailerDomain: 'whirlpool.com',
  retailerFieldEnabledBrands: [],
  serializationApi: 'serializationApi',
  usaServiceBaseUrl: 'https://api.aws.test.test.domgenusa-test.cloud',
  registrationBaseUrl:
    'https://api.global-reg.e2e-domgendotcom-qa.aws.domgencloud.net/v2',
  warrantyLengthInYears: 1,
  wibApi: 'wibApi',
};
